import Rect from 'editor/geometry/Rect';

type Modes = 'create' | 'update';

export interface UpdateTextInteractionStorage {
  box: Rect;
  element: HTMLTextAreaElement;
  elAdded: boolean;
  mode: Modes;
}

class UpdateTextInteraction {
  box: Rect;

  element: HTMLTextAreaElement;

  elAdded = false;

  mode: Modes;

  constructor(storage: UpdateTextInteractionStorage) {
    this.box = storage.box;
    this.element = storage.element;
    this.elAdded = storage.elAdded;
    this.mode = storage.mode;
  }
}

export default UpdateTextInteraction;
